// extracted by mini-css-extract-plugin
export var editInput = "_go-0";
export var editInputCompact = "_go-2";
export var editInputLarge = "_go-1";
export var editInputSmall = "_go-3";